import React from "react";
import { MdLanguage } from "react-icons/md";
import { Menu } from "antd";
import { withRouter } from "react-router-dom";
import "./LanguageChangingDropdown.css";
import Swal from "sweetalert2";
class LanguageChangingDropdown extends React.Component {
  handleChangeLanguage = (languageToChange) => {
    Swal.fire({
      title: "تغيير اللغة",
      text: "يرجى اختيار لغتك المفضلة",
      icon: "question",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "العربية",
      denyButtonText: "English",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.setItem("lang", "AR");
        this.props.history.go("/");
      } else if (result.isDenied) {
        localStorage.setItem("lang", "EN");
        this.props.history.go("/");
      }
    });
  };
  render() {
    const menu = (
      <Menu className="lang_change_dropdown">
        <Menu.Item
          className="lang_change_dropdown_item"
          onClick={this.handleChangeLanguage.bind(this, "en")}
        >
          English
        </Menu.Item>
        <Menu.Item
          className="lang_change_dropdown_item"
          onClick={this.handleChangeLanguage.bind(this, "ar")}
        >
          Arabic
        </Menu.Item>
      </Menu>
    );
    return (
      <div
        style={{
          float: localStorage.getItem("lang") === "EN" ? "right" : "left",
        }}
      >
        <i onClick={this.handleChangeLanguage} className="iconLanguage">
          <MdLanguage />
        </i>
        {/* <Dropdown overlay={menu} >
          <button className="ant-dropdown-link link-button" >
                <span> </span>
               <Icon type="global" id="langIcon" theme="outlined" className="icon"/>
         </button>
         </Dropdown>  */}
      </div>
    );
  }
}

export default withRouter(LanguageChangingDropdown);
